import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FeatherModule } from 'angular-feather';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

import { ValueComponent } from '~/v2/core/valuecomponent';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-email-field',
  templateUrl: './email-field.component.html',
  imports: [FeatherModule, NgbTooltip, FormsModule, NgClass, TranslatePipe],
})
export class EmailFieldComponent extends ValueComponent<string> implements OnChanges {
  @Input() title: string | null = null;
  @Input() isReadOnly = false;
  @Input() readOnlyIfComplete = false;
  @Input() disabled = false;
  @Input() tooltip: string | null = null;
  @Input() readonlyTooltip: string | null = null;
  @Input() emailAddressIsDuplicate = false;

  showReadonlyView = false;
  initialValue: string | null = null;
  showReadonlyTooltip = false;

  constructor() {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['isReadOnly']) {
      return;
    }
    const valueIsChanged = changes['isReadOnly'].currentValue !== changes['isReadOnly'].previousValue;
    const valueWasUndefined = changes['isReadOnly'].previousValue === undefined;

    if (valueWasUndefined && changes['isReadOnly'].currentValue) {
      this.showReadonlyView = true;
      return;
    }

    if (!valueIsChanged) {
      return;
    }

    this.initialValue = JSON.parse(JSON.stringify(this.value));
    this.showReadonlyView =
      this.isReadOnly || (this.readOnlyIfComplete && this.value !== null && this.initialValue !== null);
  }

  isEmpty(): boolean {
    return this.value == undefined || this.value == null || this.value == '';
  }
}
